import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_NAMESPACE, FALLBACK_LOCALE } from '@shared/i18n/settings'
import { resolveLocale } from '@/i18n/resolveLocale'
import commonEN from './locales/en/common.json'
import commonIT from './locales/it/common.json'

export const i18nResources = {
  it: { [DEFAULT_NAMESPACE]: commonIT },
  en: { [DEFAULT_NAMESPACE]: commonEN },
}

/**
 * Inizializza l'istanza globale di i18next. `initReactI18next` la registra
 * per `useTranslation`, quindi non serve un provider React attorno all'app.
 */
export const initI18n = () => {
  if (i18next.isInitialized) {
    return i18next
  }

  i18next
    .use(initReactI18next)
    .init({
      lng:           resolveLocale(),
      fallbackLng:   FALLBACK_LOCALE,
      defaultNS:     DEFAULT_NAMESPACE,
      resources:     i18nResources,
      interpolation: { escapeValue: false },
    })
    .catch(console.error)

  return i18next
}
